import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { KanaalWrapperComponent, KopwebCoreModule, KopWrapperComponent, NewKopComponent } from 'kopweb-core';
import { provideRouter, RouterModule, Routes } from '@angular/router';
import { provideMarkdown } from 'ngx-markdown';
import { AuthModule, provideAuth0 } from '@auth0/auth0-angular';
import { HttpClient, provideHttpClient } from '@angular/common/http';


import config from '../../auth_config.json';
import { BadgeComponent } from './auth/badge/badge.component';
import { AuthContentComponent } from './auth/auth-content/auth-content.component';
import { KlantListComponent } from './koppen/klant-list/klant-list.component';
import { BrowserKopWrapperComponent } from './koppen/browser-kop-wrapper/browser-kop-wrapper.component';
import { FeedbackFormComponent } from './feedback-form/feedback-form.component';
import { QuillModule } from 'ngx-quill';
import { KlantFormComponent } from './koppen/klant-form/klant-form.component';
import { EditLockComponent } from './lock/edit-lock/edit-lock.component';
import { TextViewerComponent } from './text-viewer/text-viewer.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';

const { domain, clientId, authorizationParams, apiUri, errorPath} = config as {
  domain: string;
  clientId: string;
  authorizationParams: any;
  apiUri: string;
  errorPath: string;
};

authorizationParams.redirect_uri = window.location.origin;

export const environment = {
  production: false,
  auth: {
    domain,
    clientId,
    authorizationParams: authorizationParams,
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/*`],
  },
};



const routes: Routes = [
  { path: 'KNL/:klantNo', component: KanaalWrapperComponent },
  { path: 'NEW/:klantNo', component: NewKopComponent },
  { path: 'SXB/:klantNo', component: BrowserKopWrapperComponent },
  { path: 'VIEWER', component: TextViewerComponent },
  { path: '', component: KlantListComponent }
]
@NgModule({
  declarations: [
    AppComponent,
    BadgeComponent,
    AuthContentComponent,
    KlantListComponent,
    BrowserKopWrapperComponent,
    FeedbackFormComponent,
    KlantFormComponent,
    EditLockComponent,
    TextViewerComponent,
    ReleaseNotesComponent
  ],
  imports: [
    BrowserModule,
    KopwebCoreModule, RouterModule,
    AuthModule.forRoot(environment.auth),
    QuillModule.forRoot()
  ],
  providers: [provideHttpClient(), provideMarkdown({ loader: HttpClient }), provideRouter(routes),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
